import { request } from "@/api";
import cookies from 'js-cookie';

const ENDPOINT_ACHIEVEGOAL_HISTORY = 'AchieveGoal/History';

export default {
    namespaced: true,
    state: {
        bigDataGuideHistory: null
    },
    actions: {
        async getHistory ({ state }) {
            const resp = await request(ENDPOINT_ACHIEVEGOAL_HISTORY, "post", {
                uId: cookies.get('UID'),
                appType: cookies.get('AppType'),
                appVersion: cookies.get('AppVersion'),
                languageCode: cookies.get('LanguageCode'),
                countryCode: cookies.get('CountryCode'),
                utcInterval: cookies.get('UTCInterval'),
                whereToUseCode: cookies.get('WhereToUseCode') === undefined ? null : cookies.get('WhereToUseCode')
            });
            if (resp.data !== undefined && resp.data !== null) {
                console.log(resp.data);
                state.bigDataGuideHistory = resp.data.yearList;
                
                /**
                 * 진행중인 목표 분리
                 */
                let nowData = null;
                let nowDataIdx = 0;
                try{
                    for (let i = 0; i < state.bigDataGuideHistory[0].dashBoardList.length; i++) {
                        let tempData = state.bigDataGuideHistory[0].dashBoardList[i];
                        if (tempData.changeRatioStatusText !== 'END') {
                            nowDataIdx = i;
                            nowData = tempData;
                            break;
                        }
                    }
                } catch (e) { console.log('e :' + e) }

                // 진행중인 목표가 있는 경우
                if (nowData !== null) {
                    let nowObject = {
                        dashBoardList: [nowData],
                        year: 'now'
                    }
                    state.bigDataGuideHistory.unshift(nowObject);
                    state.bigDataGuideHistory[1].dashBoardList.splice(nowDataIdx,1);
                }
            }
        }
    },
    mutations: {
    }
}